import React from 'react'
import Link from 'gatsby-link'

import styles from './menus.module.css'

const list = entries => (
  <ul>
    {entries.map((e, i) => (
      <li
        key={i}
        className={e.active ? styles.activeItem : styles.inactiveItem}
      >
        <Link to={e.path}>{e.title}</Link>
        {e.children instanceof Array && list(e.children)}
      </li>
    ))}
  </ul>
)

export const LeftMenu = ({ entries }) => (
  <div className={styles.menu}>{list(entries)}</div>
)

export class SmallMenu extends React.Component {
  constructor(props) {
    super(props)
    this.state = { showMenu: true }
  }

  render() {
    return (
      <div
        className={`${styles.smallMenu} ${this.state.showMenu
          ? styles.open
          : styles.closed}`}
      >
        <div onClick={() => this.setState({ showMenu: !this.state.showMenu })}>
          <span>{'\u25b2'}</span>
        </div>
        {list(this.props.entries)}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/layouts/menus.js